import { createFileRoute } from "@tanstack/react-router";

import { BaseEditCreateModal } from "@/components/_Modals/BaseEditCreateModal";

import { Content } from "@/features/dashboard/configuracoes/popups/$id/components/PopupsContent";

export const Route = createFileRoute("/_private/dashboard/_settings/configuracoes/popups/$id/modal")({
  component: ModalOrder
});

function ModalOrder() {
  return (
    <BaseEditCreateModal title="Editar Popup" from="/dashboard/configuracoes/popups/$id">
      <Content />
    </BaseEditCreateModal>
  );
}
